import React from 'react';
import { Paper, Container } from '@mui/material';

interface StepContainerProps {
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const StepContainer: React.FC<StepContainerProps> = ({
  children,
  maxWidth = 'xl',
}) => {
  return (
    <Container maxWidth={maxWidth} sx={{ mt: 2, mb: 4 }}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          minHeight: '60vh',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        {children}
      </Paper>
    </Container>
  );
};

export default StepContainer;
